import React from 'react';
import { Form, Input, Select, Row, Col } from 'antd';
import { PARTNER_STATUS, PARTNER_STATUS_LABELS } from '../../utils/constants';
import { partnerFormRules } from '../../utils/validation';
import LogoUploader from '../shared/LogoUploader';

const { Option } = Select;
const { TextArea } = Input;

const PartnerBasicInfo = ({ form, disabled = false }) => {
  const partnerName = Form.useWatch('name', form);

  return (
    <div>
      <Row gutter={24}>
        <Col xs={24} sm={24} md={8} style={{ textAlign: 'center' }}>
          <Form.Item
            label="Logo"
            name="logo"
            valuePropName="file"
            style={{ marginBottom: 0 }}
          >
            <LogoUploader partnerName={partnerName} disabled={disabled} />
          </Form.Item>
          <p style={{ marginTop: 8, color: '#8c8c8c', fontSize: 12 }}>
            Max 2MB. JPG, PNG, or SVG
          </p>
        </Col>

        <Col xs={24} sm={24} md={16}>
          <Form.Item
            label="Partner Name"
            name="name"
            rules={partnerFormRules.name}
            required
          >
            <Input
              placeholder="Enter partner name"
              disabled={disabled}
              maxLength={100}
              showCount
            />
          </Form.Item>

          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item label="Email" name="email" rules={partnerFormRules.email} required>
                <Input
                  type="email"
                  placeholder="partner@example.com"
                  disabled={disabled}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item label="Phone" name="phone" rules={partnerFormRules.phone} required>
                <Input
                  placeholder="+373 XX XXX XXX"
                  disabled={disabled}
                />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item label="Status" name="status" rules={partnerFormRules.status} required>
            <Select placeholder="Select status" disabled={disabled}>
              {Object.values(PARTNER_STATUS).map((status) => (
                <Option key={status} value={status}>
                  {PARTNER_STATUS_LABELS[status]}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>

      <Form.Item label="Description" name="description">
        <TextArea
          rows={4}
          placeholder="Enter partner description (optional)"
          disabled={disabled}
          maxLength={500}
          showCount
        />
      </Form.Item>
    </div>
  );
};

export default PartnerBasicInfo;
